import { formatPrice } from '@/utils/priceHelper'
import currencyJs from 'currency.js'

export type PriceSign = 'positive' | 'negative' | 'dynamic' | 'negative-only'

export const formatSignedPrice = (
    amount: string,
    currency: string,
    sign: PriceSign,
    minimumPrecision?: number
): string => {
    const parsedAmount = currencyJs(amount)

    if (parsedAmount.value === 0) {
        return formatPrice(parsedAmount.toString(), currency, false, minimumPrecision)
    }

    const negative =
        sign === 'negative' ||
        ((sign === 'dynamic' || sign === 'negative-only') && parsedAmount.value < 0)
    const positive = sign === 'positive' || (sign === 'dynamic' && parsedAmount.value > 0)
    const absoluteAmount = parsedAmount.value < 0 ? parsedAmount.multiply(-1) : parsedAmount
    const formattedAmount = formatPrice(
        absoluteAmount.toString(),
        currency,
        false,
        minimumPrecision
    )

    if (!negative && !positive) return formattedAmount

    return `${negative ? '-' : '+'} ${formattedAmount}`
}
